export const ecosystemHero = {
  badge: "Our Ecosystem",
  title: "A Network Built for Impact",
  subtitle:
    "TIE's ecosystem brings together industry associations, strategic factory partners, research institutions, and global buyers to create an innovation infrastructure that no single organization could build alone.",
  ctaPrimary: "Join the Ecosystem",
  ctaSecondary: "Explore Partners",
};

export const ecosystemPillars = [
  {
    title: "Industry Associations",
    description:
      "BKMEA and BGBA provide sector-wide reach, credibility, and access to hundreds of member factories. They shape the policy environment and champion innovation at the national level.",
    icon: "ri-building-2-line",
    stat: "600+",
    statLabel: "Member Factories",
  },
  {
    title: "Strategic Factory Partners",
    description:
      "Leading factory groups - Micro Fibre, Essential Clothing, APS Knit, HAMS, AukoTex, Aux & Hue, Raas Biotech, Arien Knit, MB Knit Fashion, Fashion Power - serve as early adopters, co-developers, and demonstration sites for new innovations.",
    icon: "ri-building-4-line",
    stat: "10",
    statLabel: "Anchor Partners",
  },
  {
    title: "Research & Academia",
    description:
      "Universities and research institutions contribute applied research, graduate talent, and peer-reviewed validation that elevates factory-level findings into sector knowledge.",
    icon: "ri-graduation-cap-line",
    stat: "12",
    statLabel: "Research Partners",
  },
  {
    title: "Global Buyers & Brands",
    description:
      "International brands and buying houses connect factory innovations to market demand. They provide specifications, sustainability requirements, and procurement incentives.",
    icon: "ri-shopping-bag-2-line",
    stat: "30+",
    statLabel: "Brand Partners",
  },
  {
    title: "Technology Providers",
    description:
      "Solution providers - from automation vendors to chemical innovators - gain a curated marketplace through TIE's Expo and direct factory matchmaking programmes.",
    icon: "ri-cpu-line",
    stat: "200+",
    statLabel: "Expo Exhibitors",
  },
  {
    title: "Expert Community",
    description:
      "150+ seasoned specialists across lean manufacturing, dyeing, compliance, digital systems, and sustainability form TIE's on-demand advisory capacity.",
    icon: "ri-user-star-line",
    stat: "150+",
    statLabel: "TIE Experts",
  },
];

export const ecosystemHowItWorks = [
  {
    step: "01",
    title: "Identify",
    description:
      "Factories and partners signal needs, challenges, and innovation priorities through TIE's diagnostic tools and quarterly sector surveys.",
  },
  {
    step: "02",
    title: "Connect",
    description:
      "TIE matchmakes factories with relevant experts, technology providers, and research partners based on specific operational contexts and goals.",
  },
  {
    step: "03",
    title: "Co-Create",
    description:
      "Cross-functional Innovation Circles and Applied Research Circles generate, test, and validate solutions on the factory floor in real production conditions.",
  },
  {
    step: "04",
    title: "Validate",
    description:
      "Independent assessment, peer review, and evidence documentation ensure that solutions are robust, repeatable, and ready for broader adoption.",
  },
  {
    step: "05",
    title: "Scale",
    description:
      "Validated innovations are disseminated through TIE's network of 80+ factories, the annual Expo, publications, and the Experts' Platform.",
  },
  {
    step: "06",
    title: "Recognize",
    description:
      "Factories and individuals earn TIE Innovation Readiness Certification and annual awards that signal capability to buyers, investors, and the sector.",
  },
];

export const ecosystemGovernance = {
  title: "Governance & Stewardship",
  subtitle:
    "TIE operates under a multi-stakeholder governance model that ensures balanced representation from factories, associations, academia, and industry leadership.",
  description:
    "The Steering Board convenes quarterly to set strategic priorities, approve new programmes, and oversee resource allocation. An independent secretariat manages day-to-day operations, reporting, and partner coordination.",
  boardHighlights: [
    { label: "Steering Board Members", value: "10" },
    { label: "Quarterly Meetings", value: "4 / year" },
    { label: "Secretariat Team", value: "2 Leads" },
    { label: "Governance Since", value: "2026" },
  ],
};